import React, { useState, useEffect } from 'react';
import { Button, Table, Container, Alert, Modal, Form } from 'react-bootstrap';
//import api from '../../redux/actions/configApi'; // Assumindo que a API está configurada nesse arquivo
import Loader from '../../../components/loading';
import { useSelector, useDispatch } from 'react-redux';
import { fetchVendas, updateStatusVenda } from '../../../redux/reducers/vendasSlice';
import PaginationComponent from '../../../components/paginacao';

const Vendas = () => {

    const [selectedVenda, setSelectedVenda] = useState(null);
    const [success, setSuccess] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showAlert, setAlert] = useState(false);
    const [showModalStatus, setShowModalStatus] = useState(false);
    const [status, setStatus] = useState('1');
    const dispatch = useDispatch();
    const { vendas, loading, error, message } = useSelector((state) => state.vendas);
    const [currentPage, setCurrentPage] = useState(1);
    //Paginacao
   
    const itemsPerPage = 10
    const totalPages = Math.ceil(vendas?.total / itemsPerPage);
 

    const STATUS_MAP = {
        1: "Pendente",
        2: "Aprovado",
        3: "Cancelado",
    };
    const getStatusLabel = (value) => STATUS_MAP[value] || "Desconhecido";

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage)
        dispatch(fetchVendas(newPage));
    };

    useEffect(() => {
        dispatch(fetchVendas(currentPage));
    }, [dispatch]);

    useEffect(() => {
        setAlert(true)
    }, [message]);

    // Função para visualizar detalhes do pedido
    const handleViewDetails = (venda) => {
        setSelectedVenda(venda);
        setShowModal(true);
    };

    // Função para abrir o modal de alteração de status
    const handleStatusChange = (venda) => {
        setSelectedVenda(venda);
        setShowModalStatus(true)
    };

    const handleStatusSave = async () => {
        dispatch(updateStatusVenda({ id: selectedVenda.id, status }));
        setShowModalStatus(false); // Fecha o modal após a atualização
    };



    return (
        <Container>
            <h2 className='text-center mb-4'>Vendas</h2>
            {message && (
                <Alert className="text-center" variant="success" show={showAlert}>
                    {message}
                    <Button className="m-3" variant="close" onClick={() => setAlert(false)}></Button>
                </Alert>
            )}
            {error && (
                <Alert className="text-center" variant="danger">
                    <div>{JSON.stringify(error)}</div>
                    <Button className="m-3" variant="close" ></Button>
                </Alert>
            )}
            <div className='d-flex justify-content-center'>
                <PaginationComponent
                    currentPage={currentPage}
                    lastPage={totalPages}
                    onPageChange={handlePageChange}
                />
            </div>
            <div className={`loading ${loading ? 'loading-active' : ''}`}>
                <Loader loading={loading} />
                <Table striped bordered hover responsive className='text-center mt-4' style={{ fontSize: '0.8em' }}>
                    <thead>
                        <tr>
                            <th>N° pedido</th>
                            <th>Cliente</th>
                            <th>Data do Pedido</th>
                            <th>Status</th>
                            <th>Forma de Pagamento</th>
                            <th>Total</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vendas?.data?.map((venda, index) => (
                            <tr key={venda.id}>
                                <td>{venda.order_code}</td>
                                <td>{venda.user?.name || 'Cliente não identificado'}</td>
                                <td>{new Date(venda.created_at).toLocaleDateString()}</td>
                                <td>{getStatusLabel(venda.payment?.status)}</td>
                                <td>{venda.payment?.payment_method || 'N/A'}</td>
                                <td>{!isNaN(Number(venda.total_price)) ? Number(venda.total_price).toFixed(2) : 'Valor inválido'}</td>
                                <td>
                                    <Button
                                        variant="info"
                                        size="sm"
                                        className="me-2"
                                        onClick={() => handleViewDetails(venda)}
                                    >
                                        Visualizar
                                    </Button>
                                    <Button
                                        variant="warning"
                                        size="sm"
                                        onClick={() => handleStatusChange(venda)}
                                    >
                                        Alterar Status
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Modal para visualizar detalhes */}
            <Modal className="modal-custom" show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes do Pedido</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedVenda && (
                        <div>
                            <p><strong>Cliente:</strong> {selectedVenda.user?.name}</p>
                            {/*<p><strong>Endereço:</strong> {selectedVenda.address?.address_line}</p>*/}
                            <p><strong>Status: </strong>{getStatusLabel(selectedVenda.payment?.status)} </p>
                            <p><strong>Forma de Pagamento:</strong> {selectedVenda.payment?.payment_method}</p>
                            <p><strong>Total:</strong> R$ {!isNaN(Number(selectedVenda.total_price)) ? Number(selectedVenda.total_price).toFixed(2) : 'valor inválido'}</p>
                            <h5>Produtos:</h5>
                            <ul>
                                {selectedVenda?.order_items?.map((item) => (
                                    <li key={item.id}>
                                        {item.product.name} - {item.quantity} x R$ {Number(item.unit_price).toFixed(2)} = R$ {Number(item.total_price).toFixed(2)}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            {/* Modal para alterar status */}
            <Modal show={showModalStatus} onHide={() => setShowModalStatus(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Alterar Status do Pedido</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Form.Group controlId="status">
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                            as="select"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="1">Pendente</option>
                            <option value="2">Aprovado</option>
                            <option value="3">Cancelado</option>
                        </Form.Control>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalStatus(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleStatusSave}>
                        {loading ? 'Atualizando...' : 'Atualizar Status'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default Vendas;
